import React, { useState } from "react";
import { HiMenu, HiOutlineX } from "react-icons/hi";
import { BiCode } from "react-icons/bi";
import styled, { css } from "styled-components";

const StyledNavbar = styled.nav`
  position: fixed;
  height: 4rem;
  z-index: 20;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: black;
  transition: all 0.2s ease-in;
  background-color: white;
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

  ${({ isNavbarActive }) =>
    isNavbarActive &&
    css`
      display: ${(props) => (props.isModalOpen ? "none" : "flex")} !important;
      background-color: white;
      --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.06);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    `}

  ${({ isBurgerActive }) =>
    isBurgerActive &&
    css`
      background-color: white;
      --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.06);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    `}

    
  @media (min-width: 768px) {
    height: 5rem;
  }
`;

const StyledAnchor = styled.a`
  font-weight: 700;
  background: linear-gradient(
    90deg,
    hsla(234, 89%, 74%, 1) 0%,
    hsla(213, 94%, 68%, 1) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -moz-text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
`;

const StyledUL = styled.ul`
  min-width: 100vw;
  min-height: 100vh;
  background: #dbeafe;
  transition: transform 0.2s ease-in;
  transform: translateX(100%);

  ${({ isNavListActive }) =>
    isNavListActive &&
    css`
      transform: translateX(0);
    `}

  @media (min-width: 768px) {
    all: unset;
    display: flex;
    justify-content: space-around;
    position: absolute;
    right: 1rem;
    width: 50%;
    padding: 0 1rem;
    margin-right: 1rem;
  }
  @media (min-width: 1024px) {
    width: 35%;
    right: 2rem;
    margin-right: 2rem;
  }
`;

const Navbar = ({ isModalOpen, burgerState, setBurgerState }) => {
  const [navbarState, setNavbarState] = useState(false);
  const navList = [
    {
      id: 2,
      navLi: "About",
      to: "#about",
    },
    {
      id: 3,
      navLi: "Skills",
      to: "#skills",
    },
    {
      id: 4,
      navLi: "Projects",
      to: "#projects",
    },
    {
      id: 5,
      navLi: "Contact",
      to: "#contact",
    },
  ];

  const handleBurgerClick = () => {
    setBurgerState(!burgerState);
  };

  const handleNavbarState = () => {
    if (window.scrollY >= 80) {
      setNavbarState(true);
    } else {
      setNavbarState(false);
    }
  };

  window.addEventListener("scroll", handleNavbarState);
  return (
    <StyledNavbar
      className="p-4 md:p-6"
      isNavbarActive={navbarState}
      isBurgerActive={burgerState}
      isModalOpen={isModalOpen}
    >
      <div className="flex items-center cursor-pointer h-full md:ml-10 lg:ml-20">
        <BiCode className="mr-1 h-8 w-8 text-indigo-400" />
        <StyledAnchor href="#" className="font-rubik text-2xl">
          PRNS
        </StyledAnchor>
      </div>
      <StyledUL
        isNavListActive={burgerState}
        className="font-karla flex flex-col pt-20 items-center fixed top-14 h-screen left-0"
      >
        {navList.map((list) => (
          <li
            className="font-rubik transition duration-200 ease-in-outtext-2xl py-4 cursor-pointer md:text-lg hover:text-indigo-400 px-2"
            key={list.id}
            onClick={() => {
              setBurgerState(false);
            }}
          >
            <a href={list.to}>{list.navLi}</a>
          </li>
        ))}
      </StyledUL>
      {burgerState === false ? (
        <HiMenu
          className="h-full w-8 cursor-pointer md:hidden"
          onClick={handleBurgerClick}
        />
      ) : (
        <HiOutlineX
          className="h-full w-8 cursor-pointer md:hidden"
          onClick={handleBurgerClick}
        />
      )}
    </StyledNavbar>
  );
};

export default Navbar;
